import React, { useEffect, useState } from 'react';
import { Badge, IconButton } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { contarSolicitacoesDocumentoPendentes } from '../../services/solicitacaoDocumento';

const NotificationBell: React.FC = () => {
  const [count, setCount] = useState<number>(0);
  const history = useHistory();

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const { data } = await contarSolicitacoesDocumentoPendentes();
        setCount(data.count || 0);
      } catch (error) {
        setCount(0);
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    history.push('/workspace/atividades');
  };

  return (
    <IconButton onClick={handleClick} color="inherit">
      <Badge badgeContent={count} color="error">
        <Notifications style={{ color: '#fff' }} />
      </Badge>
    </IconButton>
  );
};

export default NotificationBell;
